<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex flex-column">
            <h3 class="card-label fw-bold fs-3 mt-3">
              {{ notificationConfig.pageTitleKey | translate }}
            </h3>
          </div>
        </div>

        <div class="col-12">
          <div *ngIf="isLoading" class="d-flex justify-content-center pb-4">
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden"
                >{{ "loading" | translate }}...</span
              >
            </div>
          </div>

          <div
            *ngIf="!isLoading && notifications.length === 0"
            class="py-5 text-center fs-5"
          >
            {{ "notificationTable.noNotificationsFound" | translate }}
          </div>

          <div class="grid-header" [style.grid-template-columns]="gridTemplate">
            <ng-container *ngFor="let col of notificationConfig.columns">
              <div [ngClass]="getColClass(col.key)">
                {{ col.labelKey | translate }}
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="!isLoading && notifications.length > 0">
            <app-dynamic-list
              *ngFor="let notification of notifications"
              [item]="notification"
              [columns]="notificationConfig.columns"
              [actions]="notificationConfig.actions"
              [style.grid-template-columns]="gridTemplate"
              (click)="onCardClick(notification)"
            >
            </app-dynamic-list>
          </ng-container>
        </div>

        <div class="d-flex flex-stack flex-wrap pt-10">
          <div class="d-flex align-items-center gap-6">
            <div class="flex align-items-center">
              <label class="me-2 fs-6 fw-semibold text-gray-700">
                {{ "pageSize" | translate }}:
              </label>
              <select
                (change)="changePageSize($event)"
                [(ngModel)]="pageSize"
                class="cursor-pointer outline-none"
              >
                <option *ngFor="let size of pageSizes" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>
            <div class="fs-6 fw-semibold text-gray-700">
              {{ "showing" | translate }} {{ notifications.length }}
              {{ "of" | translate }} {{ totalItems }}
              {{ "notificationTable.notifications" | translate }}
            </div>
          </div>

          <ul class="pagination">
            <li
              class="page-item previous cursor-pointer"
              [class.disabled]="currentPage === 1"
            >
              <a class="page-link" (click)="previousPage(currentPage)">
                <i class="previous"></i>
              </a>
            </li>

            <li
              *ngFor="let page of [].constructor(totalPage); let i = index"
              class="page-item cursor-pointer"
              [class.active]="currentPage === i + 1"
            >
              <a class="page-link" (click)="changePage(i)">
                {{ i + 1 }}
              </a>
            </li>

            <li
              class="page-item next cursor-pointer"
              [class.disabled]="currentPage === totalPage"
            >
              <a class="page-link" (click)="nextPage(currentPage + 1)">
                <i class="next"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
